import { defineComponent as _defineComponent } from 'vue'
import FormattedNumber from 'ah-common-lib/src/number/FormattedNumber.vue';
import SimpleDoughnutChart from 'ah-reports/src/components/SimpleDoughnutChart.vue';
import { ClientRiskCollateralProfile } from 'ah-api-gateways';
import { FilledChartColorOptions } from 'ah-reports';
import { PostedCollateralNotionalDataType } from './interfaces';
import { VCol, VRow } from 'ah-common-lib/src/common/components';
import { computed, PropType } from 'vue';
import { darkGreen, lightGreen } from '../../helpers/chartConfig';


export default /*#__PURE__*/_defineComponent({
  __name: 'PostedCollateral',
  props: {
  collateralProfileData: { type: Object as PropType<ClientRiskCollateralProfile>, required: true },
},
  setup(__props) {

const props = __props;



const notionalData = computed<PostedCollateralNotionalDataType>(() => ({
  eur: props.collateralProfileData.eurPostedCollateral,
  eurGbpEquivalent: props.collateralProfileData.eurPostedCollateralCurrencyEquivalent,
  gbp: props.collateralProfileData.gbpPostedCollateral,
  gbpGbpEquivalent: props.collateralProfileData.gbpPostedCollateralCurrencyEquivalent,
  usd: props.collateralProfileData.usdPostedCollateral,
  usdGbpEquivalent: props.collateralProfileData.usdPostedCollateralCurrencyEquivalent,
  totalGbpEquivalent: props.collateralProfileData.totalPostedCollateral,
}));

const chartColors: FilledChartColorOptions[] = [darkGreen, lightGreen].map((color) => ({
  backgroundColor: color,
  borderColor: color,
  hoverBackgroundColor: color,
  hoverBorderColor: color,
}));

const usageInfo = computed(() => [
  { label: 'IM Requirement', value: props.collateralProfileData.totalInitialMarginCollateralFunding },
  { label: 'VM Requirement', value: props.collateralProfileData.variationMarginAmountRequired },
  { label: 'Total', value: props.collateralProfileData.totalCollateralInUse },
]);

const totalAvailableCollateral = computed<number>(() => props.collateralProfileData.availableCollateral ?? '');

return { __sfc: true,props, notionalData, chartColors, usageInfo, totalAvailableCollateral, FormattedNumber, SimpleDoughnutChart, VCol, VRow }
}

})